import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="relative min-h-[80vh] w-full flex items-center justify-center py-24 overflow-hidden" data-id="element-78">
      {/* Background Image - Grayscale */}
      <div className="absolute inset-0 z-0 grayscale" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1506377295352-e3154d43ea9e?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-79">
        <div className="absolute inset-0 bg-black/70" data-id="element-80" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 text-center text-white max-w-3xl" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-82">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-8 text-gray-100" data-id="element-83">
            Cuando nadie lo espera, la vida golpea.
          </h2>

          <p className="text-lg md:text-xl leading-relaxed font-light mb-10 text-gray-300" data-id="element-84">
            Él trabajaba todos los días, ahorraba algo en el banco… hasta que un
            infarto inesperado le quitó la vida. Y su familia quedó desamparada,
            sin un plan, sin respaldo.
          </p>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.6
        }} className="text-xl md:text-2xl font-serif italic text-magi-beige" data-id="element-85">
            ¿Cómo estarían hoy si hubieran tenido una protección financiera
            real?
          </motion.p>
        </motion.div>
      </div>
    </section>;
}